/**
 * 获取网络邮箱列表
 * @param {Object} self 调用页面的实例
 */
export const networkMailbox = async function(self) {
    let temp = [];
    const success = (res => {
        temp = is_empty(res.data) ? [] : res.data;
    })

    await self.$ajax({
        url: "api/email/configlist",
        method: "get",
        params: {},
        func: {success: success}
    });

    return temp;
}